import { Address } from "viem";
import * as chains from "./chains";

import { VALID_CHAINS, VALID_CONNECTORS, VALID_CHAINID_MAP, } from "./const";

import type { ChainInfo, ValidChainId, ValidConnectorName, } from "./types";


export const isValidChainId = ( value: unknown ): value is ValidChainId => {
	if( typeof value === "number" ) {
		return !!VALID_CHAINS.find(chain => chain === value);
	}
	return false;
}

export const isValidConnector = ( name: unknown ): name is ValidConnectorName => {
	return typeof name === "string" && VALID_CONNECTORS.includes(name as ValidConnectorName);
}


export const chainInfo = ( chainId: ValidChainId, ): ChainInfo => {
	if( chainId in VALID_CHAINID_MAP ) return VALID_CHAINID_MAP[chainId];
	throw new Error(`ConnectionManager::chainInfo was argued an unknown chain id ${chainId}`);
}

export const formatAddress = ( address: Address, ): string => {
	return `${address.substring(0,4)}...${address.substring(address.length-6, address.length)}`;
}
